<template>
  <div>
    <v-navigation-drawer v-model="drawer" app enable-resize-watcher mobile-breakpoint="1024">
      <v-list dense nav class="py-1">
        <v-list-item @click="settingsDialog=true">
          <v-list-item-avatar>
            <v-img cover :src="((userProfile || {}).public || {}).photoURL" alt="alt"></v-img>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{ ((userProfile || {}).public || {}).name }}</v-list-item-title>
            <v-list-item-subtitle>{{
              ((userProfile || {}).public || {}).email
            }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-divider></v-divider>

      <v-list class="pt-2">
        <v-list-item background-color="red">
          <LanguageSwitcher :dark="$vuetify.theme.dark" :solo="true"></LanguageSwitcher>
        </v-list-item>
        <v-divider></v-divider>

        <v-list-item to="/dashboard" v-if="!((userProfile || {}).userType || {}).refer">
          <v-list-item-action>
            <v-icon>home</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $language.navigation['Home'] }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click="addDrawer = true" v-if="((userProfile || {}).userType || {}).hefe">
          <v-list-item-action>
            <v-icon>post_add</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $language.navigation['Create Job'] }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item to="/hefe/payments" v-if="((userProfile || {}).userType || {}).hefe">
          <v-list-item-action>
            <v-icon>bar_chart</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $language.navigation['Payments'] }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item to="/hefe/favorites" v-if="((userProfile || {}).userType || {}).hefe">
          <v-list-item-action>
            <v-icon>group</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $language.navigation['Favorites'] }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item to="/obrero/Earnings" v-if="((userProfile || {}).userType || {}).obr">
          <v-list-item-action>
            <v-icon>bar_chart</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $language.navigation['Earnings'] }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item to="/obrero/job-search" v-if="((userProfile || {}).userType || {}).obr">
          <v-list-item-action>
            <v-icon>search</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $language.navigation['Jobs'] }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item to="/referral-dashboard" v-if="((userProfile || {}).userType || {}).refer" :disabled="!userProfile.acceptedReferralTerms">
          <v-list-item-action>
            <v-icon>dashboard</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $language.navigation['Referrals Dashboard'] }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item to="/referrals" v-if="((userProfile || {}).userType || {}).refer">
          <v-list-item-action>
            <v-icon>group</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $language.navigation['Referrals'] }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item to="/obrero/earnings" v-if="((userProfile || {}).userType || {}).refer" :disabled="!userProfile.acceptedReferralTerms">
          <v-list-item-action>
            <v-icon>bar_chart</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $language.navigation['Earnings'] }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-menu :close-on-content-click="false" :nudge-width="200" offset-x v-if="notificationCount>0">
          <template v-slot:activator="{ on, attrs }">
            <v-list-item v-bind="attrs" v-on="on">
              <v-list-item-action>
                <v-badge right overlap dot color="info" v-if="notificationCount>0">
                  <span slot="badge">{{notificationCount}}</span>
                  <!--slot can be any component-->

                  <v-icon>notifications</v-icon>
                </v-badge>
                <v-icon v-else>notifications</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ $language.settings['Notifications'] }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
          <v-card :max-height="$vuetify.breakpoint.height-272" scrollable v-show="notificationCount>0">
            <v-list two-line>
              <template v-for="(item, key, index) in (userProfile || {}).notifications">
                <v-list-item :key="item.key">
                  <v-list-item-content @click="openNotificationDialog(item, key)">
                    <v-list-item-title>{{ $language.notifications[item.notificationType] }}
                      <span class="caption">{{ item.notificationDate | formatDateTime }}</span>
                    </v-list-item-title>
                    <v-list-item-subtitle>{{
                          Array.isArray(item.notificationText)
                            ? item.notificationText[0]
                            : item.notificationText
                        }}
                      {{
                          Array.isArray(item.notificationText) ? item.notificationText[1] : ''
                        }}</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn text icon color="primary" @click="deleteNotification(item, key)">
                      <v-icon>close</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
                <v-divider v-if="notificationCount - 1 !== index" :key="index"></v-divider>
              </template>
            </v-list>
          </v-card>
        </v-menu>
        <v-list-item v-else>
          <v-list-item-action>
            <v-icon>notifications</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $language.settings['Notifications'] }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item @click="settingsDialog=true">
          <v-list-item-action>
            <v-icon>settings</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $language.navigation['Settings'] }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item href="mailto:support@hefeapp.com">
          <v-list-item-action>
            <v-icon v-html="'help_outline'"></v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $language.navigation['Help'] }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item>
          <v-list-item-avatar tile>
            <v-switch v-model="$vuetify.theme.dark" label="Dark Mode" :ripple="false"></v-switch>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>
              <span>{{ $language.navigation['Dark Mode'] }}</span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item @click="logout">
          <v-list-item-action>
            <v-icon v-html="'power_settings_new'"></v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $language.navigation['Logout'] }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <div style="position: fixed; bottom: 50px; left: 16px;" class="caption">
        {{$language.settings['version']}} {{version}}
      </div>

    </v-navigation-drawer>

    <v-app-bar app tile v-if="routeName!=='ObrJobDetails'&&routeName!=='HefeJobDetails'">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" color="primary" large>
      </v-app-bar-nav-icon>

      <v-toolbar-title :class="`${$vuetify.breakpoint.mdAndUp?'headline':'title'} ${$vuetify.theme.dark?'':'primary--text'} font-weight-bold`">
        {{displayTitle}}
      </v-toolbar-title>
      <v-spacer></v-spacer>

      <v-row no-gutters justify="end" align="end" style="z-index:10 !important">
        <v-speed-dial direction="bottom" v-click-outside="()=>{if(modeOverlay){$emit('mode-switch',false);modeOverlay = false}}">
          <template v-slot:activator>
            <v-btn outlined small rounded width="70" color="primary" style="border-width:thin" @click="()=>{$emit('mode-switch',true);modeOverlay = true}">
              <span v-if="(userProfile.userType||{}).hefe">{{$language.settings.mode['Hire']}}</span>
              <span v-if="(userProfile.userType||{}).obr">{{$language.settings.mode['Work']}}</span>
              <span v-if="(userProfile.userType||{}).refer">{{$language.settings.mode['Grow']}}</span>
            </v-btn>
          </template>
          <v-btn dark small rounded width="70" :color="(userProfile.userType||{}).hefe?'primary':'grey'" @click="switchModes('hefe')">
            {{$language.settings.mode['Hire']}}
          </v-btn>
          <v-btn dark small rounded width="70" :color="(userProfile.userType||{}).obr?'primary':'grey'" @click="switchModes('obr')">
            {{$language.settings.mode['Work']}}
          </v-btn>
          <v-btn dark small rounded width="70" :color="(userProfile.userType||{}).refer?'primary':'grey'" @click="switchModes('refer')">
            {{$language.settings.mode['Grow']}}
          </v-btn>
        </v-speed-dial>
      </v-row>
      <v-overlay v-model="modeOverlay" opacity="0.8"></v-overlay>
    </v-app-bar>

    <v-dialog v-model="settingsDialog" fullscreen persistent no-click-animation :overlay="false" transition="slide-x-transition">
      <settings v-if="!userProfile.firstEntry" @open="settingsDialog = false"></settings>
    </v-dialog>
    <v-navigation-drawer app touchless temporary v-model="addDrawer" :stateless="dialog" persistent right enable-resize-watcher mobile-breakpoint="10240" :width="$vuetify.breakpoint.width<1024?$vuetify.breakpoint.width:$vuetify.breakpoint.width-256">
      <add-job @simple-close="addDrawer = false" :is-hefe="true" :has-started="false"></add-job>

    </v-navigation-drawer>

    <v-dialog v-model="notificationDialog" max-width="320">
      <v-card v-if="thisNotification">
        <v-card-title class="headline">{{ $language.notifications[thisNotification.notificationType || ''] }}</v-card-title>
        <v-card-text class="body-1">
          {{ Array.isArray(thisNotification.notificationText) ? thisNotification.notificationText[0] : thisNotification.notificationText }} {{ Array.isArray(thisNotification.notificationText) ? thisNotification.notificationText[1] : '' }}
        </v-card-text>
        <v-card-text v-if="thisNotification.notificationType==='Payment'&&thisNotification.hefeRated=='false'">
          <span class="title">How was your experience?</span>
          <v-row align="center">
            <v-col cols="12" align="center">
              <v-rating size="24" large v-model="rating.rating" color="yellow darken-3" background-color="grey darken-1" empty-icon="$vuetify.icons.ratingEmpty"></v-rating>
              <v-textarea outlined label="Comments" v-model="rating.comment" class="mt-2"></v-textarea>
            </v-col>
          </v-row>

        </v-card-text>
        <v-card-actions>
          <v-row no-gutters align="center" justify="space-around" class="px-2">
            <v-col cols="5">
              <v-btn color="primary" block text @click.native="notificationDialog = false">{{$language.settings['Close']}}</v-btn>
            </v-col>
            <v-col cols="5">
              <v-btn color="primary" block @click.native="rate(thisNotification)" :disabled="rating.rating==null" v-if="thisNotification.notificationType==='Payment'&&thisNotification.hefeRated=='false'">{{$language.jobDetails['Rate']}}</v-btn>
              <v-btn color="primary" block @click.native="openDialog(thisNotification)" v-else>{{$language.settings['View']}}</v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar.show" :color="snackbar.status" :timeout="1500">
      <span class="align-baseline">{{ snackbar.message }} <v-icon small>check</v-icon></span>

    </v-snackbar>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Settings from '@/components/common/Settings'
import AddJob from '@/components/common/AddJob'
import LanguageSwitcher from '@/components/common/LanguageSwitcher'
import moment from 'moment'
const fb = require('@/services/firebaseConfig.js')

export default {
  components: {
    Settings,
    LanguageSwitcher,
    AddJob
  },
  props: ['routeName'],
  data () {
    return {
      modeOverlay: false,
      clipped: false,
      drawer: null,
      fixed: true,
      dialog: true,
      notificationDrawer: false,
      miniVariant: false,
      right: true,
      rightDrawer: false,
      title: 'Hefe',
      settingsDialog: false,
      notificationDialog: false,
      addDrawer: false,
      thisNotification: {
        notificationType: null,
        notificationText: null
      },
      dialogs: {
        'job-details': false
      },
      thisJob: {
        defaultTab: 'Summary'
      },
      gpsFixed: false,
      loading: false,
      rating: {
        comment: '',
        rating: null,
        ratingDate: new Date()
      },
      snackbar: {
        show: false,
        message: '',
        status: 'success'
      }
    }
  },
  computed: {
    ...mapState(['userProfile', 'currentUser', 'openSettings', 'version']),
    notificationCount () {
      if (this.userProfile.notifications !== undefined) {
        return Object.keys(this.userProfile.notifications).length
      }
      return 0
    },
    displayTitle () {
      switch (this.$route.name) {
        case 'ObrJobSearch':
          return this.$language.jobSearch['Find Jobs']
        case 'HefeFavorites':
          return this.$language.favorites['My Favorites']
        case 'Earnings':
          return this.$language.transactions['Transactions']
        case 'Payments':
          return this.$language.transactions['Transactions']
        case 'Dashboard':
          return this.$language.dashboard['Dashboard']
        case 'ReferralsDashboard':
          return this.$language.navigation['Referrals Dashboard']
        case 'Referrals':
          return this.$language.navigation['Referrals']
        case 'StripeRegistration':
          return this.$language.navigation['Stripe Registration']
        default:
          return null
      }
    },
    isHefe () {
      return ((this.userProfile || {}).userType || {}).hefe || false
    }
  },
  methods: {
    reload () {
      window.location.reload(true)
    },
    switchModes (val) {
      var updates = {}
      this.$emit('mode-switch', false)
      this.modeOverlay = false
      switch (val) {
        case 'hefe':
          updates[`/user/${this.currentUser.uid}/profile/userType/hefe`] = true
          updates[`/user/${this.currentUser.uid}/profile/userType/obr`] = false
          updates[`/user/${this.currentUser.uid}/profile/userType/refer`] = false
          fb.database.ref().update(updates)
          if (this.$route.name !== 'Dashboard') {
            this.$router.push('/dashboard')
          }
          break
        case 'obr':
          updates[`/user/${this.currentUser.uid}/profile/userType/hefe`] = false
          updates[`/user/${this.currentUser.uid}/profile/userType/obr`] = true
          updates[`/user/${this.currentUser.uid}/profile/userType/refer`] = false
          fb.database.ref().update(updates)
          if (this.$route.name !== 'Dashboard') {
            this.$router.push('/dashboard')
          }
          break
        case 'refer':
          updates[`/user/${this.currentUser.uid}/profile/userType/hefe`] = false
          updates[`/user/${this.currentUser.uid}/profile/userType/obr`] = false
          updates[`/user/${this.currentUser.uid}/profile/userType/refer`] = true
          fb.database.ref().update(updates)
          this.$router.push('/referrals')
          break
        default:
          break
      }
    },
    openDialog (data) {
      this.thisJob = {
        _key: data.jobId,
        defaultTab: data.defaultTab
      }
      data.defaultTab = this.$vuetify.breakpoint.lgAndUp ? 'Summary' : data.defaultTab
      this.notificationDialog = false
      fb.database.ref(`jobs/${data.jobId}/public/createdBy`).once('value').then((snap) => {
        var createdBy = snap.val()
        if (createdBy === this.currentUser.uid) {
          this.$router.push(`/hefe/job-details/${data.jobId}?tab=${data.defaultTab}`)
        } else {
          this.$router.push(`/obrero/job-details/${data.jobId}?tab=${data.defaultTab}`)
        }
      })

      // this.dialogs['job-details'] = true
    },
    handleClose (event) {
      this.dialogs[event.window] = false
    },
    openNotificationDialog (notification, key) {
      this.thisNotification = notification
      this.thisNotification._key = key
      this.notificationDialog = true
    },
    deleteNotification (notification, key) {
      var updates = {}
      updates[`user/${this.currentUser.uid}/profile/notifications/${key}`] = null
      fb.database.ref().update(updates)
    },
    async rate (data) {
      this.buttonLoading = true
      var updates = {}
      this.rating.ratedByName = this.userProfile.public.name
      this.rating.ratedById = this.currentUser.uid
      updates[`/jobs/${data.jobId}/applicants/${this.currentUser.uid}/hefeRated`] = true
      updates[`/user/${data.hefeId}/profile/public/ratings/${data.jobId}`] = this.rating
      updates[`user/${this.currentUser.uid}/profile/notifications/${data._key}/hefeRated`] = true
      await fb.database.ref().update(updates)
      this.rating = {
        comment: '',
        rating: null,
        ratingDate: new Date()
      }
      this.thisNotification.hefeRated = true
      this.snackbar.message = this.$language.jobDetails['Review submitted']
      this.snackbar.status = 'success'
      this.snackbar.show = true
    },

    logout () {
      fb.app
        .auth()
        .signOut()
        .then(() => {
          this.$store.dispatch('clearData')
          this.$router.push('/login')
        })
        .catch((err) => {
          console.log(err)
        })
    },

    getJobsfromGPS () {
      this.loading = true
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(async (position) => {
          this.position = position.coords
          this.$refs.searchAdd.$el.value = 'Current Location'
          var updates = {}
          updates[`user/${this.currentUser.uid}/profile/location/coords`] = [
            position.coords.latitude,
            position.coords.longitude
          ]
          await fb.database.ref().update(updates)
          this.loading = false
          this.gpsFixed = true
        })
      } else {
        this.loading = false
      }
    },
    clear () {
      // this.distance = 0
      this.$refs.searchAdd.$el.value = null
    },
    getAddressData: function (addressData, placeResultData, id) {
      var updates = {}
      updates[`user/${this.currentUser.uid}/profile/location/coords`] = [
        addressData.geometry.location.lat(),
        addressData.geometry.location.lng()
      ]
      fb.database.ref().update(updates)
    }
  },
  watch: {
    '$vuetify.theme.dark' () {
      localStorage.setItem('theme', this.$vuetify.theme.dark ? 'dark' : 'light')
    },
    openSettings () {
      this.settingsDialog = true
    }
  },
  filters: {
    formatDateTime (val) {
      if (!val) {
        return '-'
      }
      let date = new Date(val)
      return moment(date).fromNow()
    }
  }
}
</script>
